/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_ClientsInputs */

const et_hero_badge_clients = /** @type {(inputs: Hero_Badge_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`32+ rahuloleva klienti`)
};

const en_hero_badge_clients = /** @type {(inputs: Hero_Badge_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`32+ satisfied clients`)
};

/**
* | output |
* | --- |
* | "32+ satisfied clients" |
*
* @param {Hero_Badge_ClientsInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_badge_clients = /** @type {((inputs?: Hero_Badge_ClientsInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_ClientsInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_badge_clients(inputs)
	return en_hero_badge_clients(inputs)
});